import { Component, OnInit } from '@angular/core';
import { UserResponseDto } from '../../../backend/model/userResponseDto';
import { DialogService } from '../../dialog/dialog.service';
import { AuthService } from '../../services/auth.service';
import { Menu, MenuService } from '../../services/menu.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-secure-layout',
  templateUrl: './secure-layout.component.html',
  styleUrls: ['./secure-layout.component.scss'],
})
export class SecureLayoutComponent implements OnInit {
  menu: Menu | undefined;
  user: UserResponseDto | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private menuService: MenuService,
    private dialogService: DialogService
  ) {
    this.authService.refreshMe();
    this.menu = this.menuService.getCurrentUserRoleMenu();

    this.authService.onAuthChange.subscribe((res) => {
      this.user = this.authService.getUser();
    });
  }

  ngOnInit(): void {}

  logout() {
    this.authService.clearAuth();
    this.router.navigate(['/login']);
  }

  openMyAccountDialog() {}
}
